"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = mod;

// Helper modulus function used in carousel logic
function mod(index, count) {
  var q = index % count;
  return q < 0 ? q + count : q;
}
//# sourceMappingURL=mod.js.map